'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagTtAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M0 2.25V0.0178795L28 -3.8147e-06C28 -3.8147e-06 28 1.14543 28 2.25L28 20.0179C28 20.0179 27.1046 20.0179 26 20.0179H2C0.895429 20.0179 0 20.0179 0 20.0179V2.25Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M0 0.0178795L28 -3.8147e-06L28 20.0179H0V0.0178795Z",
          fill: "#ED233C"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M15.9636 20.0072L0.00432245 1.06057L0 0.0178795L12.0859 0.0217853L28 19.0023L28 20.0179L15.9636 20.0072Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M17.9933 20.0089L1 -3.8147e-06H10L26.7615 20.0179L17.9933 20.0089Z",
          fill: "#262626"
        }
      )
    ]
  }
);
const VpFlagTtAsset = forwardRef(FlagTtAsset);

export { VpFlagTtAsset as default };
